import axios from 'axios';

/**
 * The header both backends' cross-site guards look for.
 *
 * A custom header cannot be set on a cross-site request without a preflight,
 * and neither backend answers a preflight in a way that allows credentials -
 * so a request carrying this header and the session cookie together can only
 * have come from our own pages. That is the whole mechanism: see
 * pacmny-be/lib/CsrfFilter.php and keyon/lib/CsrfGuard.php.
 */
export const REQUEST_MARKER = 'X-Pacmny-Request';

/**
 * Same-origin only, and deliberately so. Adding a custom header to a
 * cross-origin request turns it into a preflighted one, which would break any
 * third-party call that works today. Both backends are reached by relative URL
 * (`/keyon` and `/pacmny-be/web/index.php`), so in practice this covers every
 * call we make to ourselves and nothing else.
 */
export function isOurOwnOrigin(url) {
  if (typeof url !== 'string' || url === '') return false;
  if (!/^[a-z][a-z0-9+.-]*:|^\/\//i.test(url)) return true; // relative
  try {
    return new URL(url, window.location.href).origin === window.location.origin;
  } catch (_) {
    return false;
  }
}

/**
 * Registered once, on the global axios instance, rather than added to each of
 * the request builders in config.js. There are several of those and hundreds of
 * call sites that bypass them entirely, and a guard that only some requests
 * satisfy is worse than no guard: it produces a rollout signal full of
 * failures that are all our own.
 */
export function installRequestMarker(client = axios) {
  client.interceptors.request.use((config) => {
    if (!isOurOwnOrigin(config.url)) return config;
    config.headers = config.headers || {};
    config.headers[REQUEST_MARKER] = '1';
    return config;
  });
}
